import { instance } from "./interceptors"


export const createDocumentUnit = async (body) => {
    const response = await instance.post('/api/create/document/', body)
    return response.data
}   


export const createDocumentWasteUnit = async (data) => {
    const response = await instance.post('/api/create/document/waste', data)
    return response.data
}   


export const updateProductsDocumentUnit = async(data) => {
    let {
        document_id,
        products
    } = data
    const response = await instance.put('/api/document/update/'+document_id, products)
    return response
}


export const createVendorDocumentUnit = async(params) => {
    const {
        type,
        data
    } = params
    const response = await instance.post(`/api/create/vendordocument/?type=${type}`, data)
    return response
}


export const createUnscheduledDocumentUnit = async(data) => {
    const response = await instance.post('/api/create/document/unscheduled', data)
    return response
}





